import React, { useState } from 'react';
import axios from 'axios';
import { ShieldCheck, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ConsentCheckbox = ({ checked, onChange, dark = true, testId = 'terms-consent-checkbox' }) => {
  const link = dark ? 'text-rose-400 hover:text-rose-300' : 'text-rose-600 hover:text-rose-700';
  return (
    <label className="flex items-start space-x-3 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
        className="mt-1 h-4 w-4 text-rose-500 border-gray-300 rounded focus:ring-rose-400 flex-shrink-0"
      />
      <span className={`text-sm ${dark ? 'text-gray-200' : 'text-gray-700'}`}>
        I'm 18 or older and I agree to the{' '}
        <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" className={`${link} underline font-medium`}>Terms of Service</a>,{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className={`${link} underline font-medium`}>Privacy Policy</a>,{' '}
        <a href="/community-guidelines" target="_blank" rel="noopener noreferrer" className={`${link} underline font-medium`}>Community Guidelines</a> and{' '}
        <a href="/cookie-policy" target="_blank" rel="noopener noreferrer" className={`${link} underline font-medium`}>Cookie Policy</a>.
      </span>
    </label>
  );
};

export const TermsGate = ({ onAccepted, onLogout }) => {
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const accept = async () => {
    setSaving(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${API}/auth/accept-terms`,
        { confirm_18_plus: true, accept_terms: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onAccepted(res.data.terms_accepted_at);
    } catch (e) {
      setError('Could not save your agreement. Please try again.');
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-rose-950 px-4" data-testid="terms-gate">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        <ShieldCheck className="w-12 h-12 text-rose-600 mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">One quick thing</h1>
        <p className="text-gray-600 text-sm mb-6">
          Shot Clock Dating is for adults only. Please confirm your age and agree to our policies to continue.
        </p>
        <ConsentCheckbox checked={checked} onChange={setChecked} dark={false} testId="terms-gate-checkbox" />
        {error && <p className="text-sm text-red-600 mt-3" data-testid="terms-gate-error">{error}</p>}
        <button
          onClick={accept}
          disabled={!checked || saving}
          data-testid="terms-gate-continue-btn"
          className="w-full mt-6 bg-rose-600 hover:bg-rose-700 disabled:opacity-40 disabled:cursor-not-allowed text-white py-3 rounded-xl font-semibold flex items-center justify-center transition-colors"
        >
          {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          Continue
        </button>
        <button onClick={onLogout} data-testid="terms-gate-logout-btn" className="w-full mt-3 text-sm text-gray-500 hover:text-gray-800">
          Log out
        </button>
      </div>
    </div>
  );
};

export default TermsGate;
